import { render, staticRenderFns } from "./VStakeholders.vue?vue&type=template&id=27f7482f&"
import script from "./VStakeholders.vue?vue&type=script&lang=js&"
export * from "./VStakeholders.vue?vue&type=script&lang=js&"
import style0 from "./VStakeholders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports